module.exports = __webpack_public_path__ + "media/images/header-bg-02-cd3902bcfea2109f567810522242d023.png";